var exports = {
  "Ew": "MessageAttachments.module__forwardedContainer___ZEwxc0",
  "iE": "MessageAttachments.module__forwardedBar___ZEwxc0",
  "Q$": "MessageAttachments.module__forwardedContent___ZEwxc0",
  "Sd": "MessageAttachments.module__forwardedHeader___ZEwxc0",
  "Q_": "MessageAttachments.module__forwardedIcon___ZEwxc0",
  "nQ": "MessageAttachments.module__forwardedLabel___ZEwxc0",
  "KK": "MessageAttachments.module__attachmentsContainer___ZEwxc0",
  "R$": "MessageAttachments.module__urlEmbedSpoiler___ZEwxc0",
  "eb": "MessageAttachments.module__forwardedSourceButton___ZEwxc0",
  "O_": "MessageAttachments.module__forwardedSourceLabel___ZEwxc0",
  "wM": "MessageAttachments.module__forwardedSourceInfo___ZEwxc0",
  "Lk": "MessageAttachments.module__forwardedSourceIcon___ZEwxc0",
  "ZF": "MessageAttachments.module__forwardedSourceAvatar___ZEwxc0",
  "qM": "MessageAttachments.module__forwardedSourceGuildIcon___ZEwxc0",
  "T5": "MessageAttachments.module__forwardedSourceChevron___ZEwxc0",
  "V0": "MessageAttachments.module__forwardedSourceName___ZEwxc0",
  "ye": "MessageAttachments.module__stickersContainer___ZEwxc0",
  "Bd": "MessageAttachments.module__stickerWrapper___ZEwxc0",
  "Rq": "MessageAttachments.module__stickerWrapperInteractive___ZEwxc0",
  "HF": "MessageAttachments.module__stickerImage___ZEwxc0",
};

module.exports = exports;
